var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.947,
    height: 64.858,
    viewBox: "0 0 86.947 64.858",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-165.357 -60)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "L",
    transform: "translate(210.031 92)",
    fontSize: 34,
    fontFamily: "Vidaloka-Regular, Vidaloka "
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    id: "G",
    transform: "translate(228.305 114.246)",
    fontSize: 34,
    fontFamily: "Vidaloka-Regular, Vidaloka "
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G")), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M17.194,62.871V51.806C5.665,51.213,0,45.77,0,45.77L13.245,20.613,9.606,6.062a28.705,28.705,0,0,1,7.586-2.048C17.356,1.657,17.888,0,19.507,0s2.16,1.687,2.319,4.079a28.955,28.955,0,0,1,7.069,1.984l-3.821,14.2L38.5,45.77s-5.71,5.486-17.333,6.043V62.871a1.986,1.986,0,1,1-3.973,0Z",
    transform: "translate(165.357 60)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x1: 23.835,
    y2: 34.957,
    transform: "translate(219.373 74.52)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bd2430540b05245d61439670a65d7b8f.svg";
export { ForwardRef as ReactComponent };